module.exports = new __parcel__URL__("96816_h.2b232305.jpg").toString();